// based on rc-cascader 0.16.0
import Cascader from './Cascader'
export default Cascader



// WEBPACK FOOTER //
// ./components/vc-cascader/index.js